import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemUpdateAtom = createMutationAtomFactory(
  'settings.itemUpdate',
  (params: {
    id: string;
    categoryId?: string | null;
    itemGroupId?: string | null;
    skuNumber?: string | null;
    name?: string | null;
    description?: string | null;
    notes?: string | null;
    pricingUnitOverride?: string | null;
    attributeValues?: Record<string, unknown> | null;
    customAttributes?: Record<string, unknown> | null;
    colorHue?: number | null;
  }) => ({
    inventoryItemUpdate: {
      __args: {
        id: params.id,
        input: {
          categoryId: params.categoryId,
          itemGroupId: params.itemGroupId,
          skuNumber: params.skuNumber,
          name: params.name,
          description: params.description,
          notes: params.notes,
          pricingUnitOverride: params.pricingUnitOverride,
          attributeValues:
            params.attributeValues != null
              ? JSON.stringify(params.attributeValues)
              : params.attributeValues,
          customAttributes: params.customAttributes,
          colorHue: params.colorHue,
        },
      },
      id: true,
      name: true,
      skuNumber: true,
      colorHue: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
